"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectedService = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const contact_profile_enum_1 = require("./contact-profile-enum");
const opportunity_1 = require("./opportunity");
const partner_1 = require("./partner");
const service_1 = require("./service");
let RejectedService = class RejectedService {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], RejectedService.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp without time zone',
        nullable: false,
        default: () => 'now()',
        name: 'created_at',
    }),
    __metadata("design:type", Date)
], RejectedService.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp without time zone',
        nullable: true,
        name: 'updated_at',
    }),
    __metadata("design:type", Date)
], RejectedService.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 18,
        name: 'service_sfid',
    }),
    __metadata("design:type", String)
], RejectedService.prototype, "serviceSfid", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 18,
        name: 'opportunity_sfid',
    }),
    __metadata("design:type", String)
], RejectedService.prototype, "opportunitySfid", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 18,
        name: 'partner_sfid',
    }),
    __metadata("design:type", String)
], RejectedService.prototype, "partnerSfid", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity, (opportunities) => opportunities.rejectedOpportunityServices, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'opportunity_sfid', referencedColumnName: 'id' }),
    __metadata("design:type", opportunity_1.Opportunity)
], RejectedService.prototype, "opportunity", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => service_1.Service, (services) => services.rejectedServices, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({ name: 'service_sfid', referencedColumnName: 'id' }),
    __metadata("design:type", service_1.Service)
], RejectedService.prototype, "service", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => partner_1.Partner, (accounts) => accounts.rejectedServicesByPartner, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'partner_sfid', referencedColumnName: 'id' }),
    __metadata("design:type", partner_1.Partner)
], RejectedService.prototype, "partner", void 0);
RejectedService = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Rejected Service',
        nameFunction: (i) => { var _a; return `${i.id}@${(_a = i.service) === null || _a === void 0 ? void 0 : _a.name}`; },
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('rejected_services', { schema: 'public' }),
    (0, typeorm_1.Unique)(['opportunitySfid', 'serviceSfid', 'partnerSfid'])
], RejectedService);
exports.RejectedService = RejectedService;
//# sourceMappingURL=rejected-service.js.map